import { useState } from "react";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import usersApi from "../../api/user/user";
import { localDayStartISO } from "../../helpers/dateFormat";
import { ui } from "../../helpers/ui";

const InitSalariesLogic = () => {
  const [clients, setClients] = useState<any[]>([]);
  const [selectedClient, setSelectedClient] = useState<any>();
  const [data, setData] = useState<any>({
    client: "",
    fromDate: "",
    toDate: "",
  });

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  const loadClients = () => {
    if (new Date(data.fromDate).toString() === "Invalid Date") {
      ui.alert("Neispravan datum Od");
      return;
    }
    if (new Date(data.toDate).toString() === "Invalid Date") {
      ui.alert("Neispravan datum Do");
      return;
    }
    usersApi
      .getUsers({
        fromDate: localDayStartISO(data.fromDate),
        toDate: localDayStartISO(data.toDate),
      })
      .then((response) => {
        if (response.status === 200) {
          setSelectedClient(undefined);
          setClients(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const selectClient = (client: any) => {
    // Zaštita od duplog klika: bez mutacije state niza
    if (selectedClient?.id === client.id) return;
    const rest = clients.filter((c: any) => c.id !== client.id);
    setClients(selectedClient !== undefined ? [...rest, selectedClient] : rest);
    setSelectedClient(client);
    // setData({ ...data, client: "" });
  };

  const removeSelectedClient = (client: any) => {
    setSelectedClient(undefined);
    setClients([...clients, client]);
    setData({ ...data, client: "" });
  };

  return {
    selectedClient,
    clients,
    data,
    onChange,
    selectClient,
    removeSelectedClient,
    loadClients,
  };
};

export default InitSalariesLogic;
